import React, { useMemo, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetDimondDetailsQuery } from "../../store/api/filterApi";
import "./DiamondDetails.css";
import Loader from "../../components/common/Loader";
import IcPlay from "../../assets/icons/IcPlay";
import { useDispatch, useSelector } from "react-redux";
import { addItemToCart } from "../../store/slices/cartSlice";
import {
  useAddItemToCartMutation,
  useGetCartItemsQuery,
} from "../../store/api/cartApi";
import diamondDummy from "../../assets/diamonds/diamond_round.png";
import certi from "../../assets/images/certificate.png";
import InlineLoaderComponent from "../../components/common/InlineLoaderComponent";

const DiamonDetails = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const [imgSrc, setImgSrc] = useState("");
  const [isVideo, setIsVideo] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const { data: dimondDetails, isLoading: dimonDetailsLoading } =
    useGetDimondDetailsQuery(params?.id);
  const [
    addItemToCart,
    { data: addedItemData, isLoading: itemAddingInProgress },
  ] = useAddItemToCartMutation();
  const handleBuy = () => {
    dispatch(addItemToCart(dimondDetails));
  };
  const { data: cartItem } = useGetCartItemsQuery();
  const handleAddItemToCart = () => {
    // dispatch(addItemToCart(dimondDetails));
    addItemToCart({
      inventoryId: dimondDetails?.id,
    });
  };
  useEffect(() => {
    if (dimondDetails?.image_url) {
      const url = dimondDetails.image_url;
      const isVideoURL =
        url.endsWith(".html") ||
        url.includes("/VIDEO/") ||
        url.includes("nivoda-inhousemedia");
      setIsVideo(url);
      setImgSrc(isVideoURL ? diamondDummy : url);
    }
  }, [dimondDetails]);
  console.log({ imgSrc });

  const disableAddtoCard = useMemo(() => {
    let isInCart = cartItem?.find(
      (item) => item?.inventory_id === dimondDetails?.id
    );
    if (isInCart) {
      return true;
    } else {
      return false;
    }
  }, [cartItem, dimondDetails]);
  return (
    <div className="custom-container position-relative">
      {dimonDetailsLoading && <Loader />}
      <div className=" diamond-details-container">
        <div className="img-section">
          <div className="sidebar">
            <div className="sidebar-item">
              <img
                onClick={() => setShowVideo(false)}
                src={imgSrc || diamondDummy}
                alt="Diamond"
                onError={() => setImgSrc(diamondDummy)}
              />
            </div>

            <div className="sidebar-item">
              <div className="play-icon" onClick={() => setShowVideo(true)}>
                <IcPlay />
              </div>
              VIDEO
            </div>
            <div className="sidebar-item certi">
              <a href={dimondDetails?.certificate_url} target="_blank">
                <img src={certi} />
              </a>
            </div>
          </div>
          <div className="main-image">
            {isVideo && showVideo ? (
              <iframe src={isVideo} className="detail-video-iframe" />
            ) : (
              <img
                src={imgSrc || diamondDummy}
                alt="Diamond"
                onError={() => setImgSrc(diamondDummy)}
              />
            )}
          </div>
        </div>
        <div className="detail-section">
          <div className="detail-section-header">
            <div className="d-flex flex-column gap-2">
              <div className="d-flex align-items-center">
                <div className="details-label-header">Stocks#</div>{" "}
                <div className="details-value status">
                  {dimondDetails?.serial_id}
                </div>
              </div>
              <div className="title">
                {dimondDetails?.shape} {dimondDetails?.carat}ct{" "}
                {dimondDetails?.color} {dimondDetails?.clarity}
              </div>
              <div className="d-flex align-items-center">
                <div className="details-label-header">Status: </div>{" "}
                <div className="details-value">
                  {dimondDetails?.is_sold ? "Sold" : "Available"}
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="details-label-header">Last Refreshed:</div>{" "}
                <div className="details-value">
                  {new Date().toLocaleDateString("en-US")}
                </div>
              </div>
            </div>
            {/* <div className="details-tag">Lab-Grown Diamonds</div> */}
          </div>
          <div className="detail-table mt-4">
            <table>
              <tbody>
                <tr>
                  <td rowSpan={2} className="span-label">
                    Price
                  </td>
                  <td className="details-label">P/ct</td>
                  <td className="details-label">Total Price</td>
                </tr>
                <tr>
                  <td className="details-value">
                    ${dimondDetails?.price_per_carat}
                  </td>
                  <td className="details-value">
                    ${dimondDetails?.total_price}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="detail-table mt-4">
            <table>
              <tbody>
                <tr>
                  <td colSpan={3} className="span-label">
                    Product Details
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="details-label">Lab</div>{" "}
                  </td>
                  <td>
                    {" "}
                    <div className="details-value">
                      {dimondDetails?.lab || "-"}
                    </div>
                  </td>
                  <td>
                    <div className="details-label">Certificate Number</div>{" "}
                  </td>
                  <td>
                    <div className="details-value">
                      {dimondDetails?.certificate_number || "-"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="details-label">Shape</div>{" "}
                  </td>
                  <td>
                    <div className="details-value">
                      {dimondDetails?.shape || "-"}
                    </div>
                  </td>
                  <td>
                    <div className="details-label">Carat</div>{" "}
                  </td>
                  <td>
                    <div className="details-value">
                      {dimondDetails?.carat || "-"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="details-label">Color</div>{" "}
                  </td>
                  <td>
                    <div className="details-value">
                      {dimondDetails?.color || "-"}
                    </div>
                  </td>
                  <td>
                    <div className="details-label">Clarity</div>{" "}
                  </td>
                  <td>
                    {" "}
                    <div className="details-value">
                      {dimondDetails?.clarity || "-"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="details-label">Cut</div>{" "}
                  </td>
                  <td>
                    <div className="details-value">
                      {dimondDetails?.cut || "-"}
                    </div>
                  </td>
                  <td>
                    <div className="details-label">Polish</div>{" "}
                  </td>
                  <td>
                    {" "}
                    <div className="details-value">
                      {dimondDetails?.polish || "-"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="details-label">Symmetry</div>{" "}
                  </td>
                  <td>
                    <div className="details-value">
                      {dimondDetails?.symmetry || "-"}
                    </div>
                  </td>
                  <td>
                    <div className="details-label">Fluor</div>{" "}
                  </td>
                  <td>
                    <div className="details-value">
                      {dimondDetails?.fluorescent || "-"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="details-label">Location</div>{" "}
                  </td>
                  <td>
                    {" "}
                    <div className="details-value">
                      {dimondDetails?.location || "-"}
                    </div>
                  </td>
                  <td>
                    <div className="details-label">Depth</div>{" "}
                  </td>
                  <td>
                    <div className="details-value">
                      {dimondDetails?.depth_percentage || "-"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="details-label">Table</div>{" "}
                  </td>
                  <td>
                    <div className="details-value">
                      {dimondDetails?.table_percentage || "-"}
                    </div>
                  </td>
                  <td>
                    <div className="details-label">Gridle</div>{" "}
                  </td>
                  <td>
                    <div className="details-value">
                      {dimondDetails?.gridle || "-"}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="details-label">Ratio</div>{" "}
                  </td>
                  <td>
                    <div className="details-value">
                      {dimondDetails?.ratio || "-"}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="button-section mt-4">
            <button
              className="filled mb-2"
              disabled={disableAddtoCard}
              onClick={handleAddItemToCart}
            >
              Add To Cart {itemAddingInProgress && <InlineLoaderComponent />}
            </button>
            {/* <button className="filled">Memo</button>
            <button className="filled" onClick={handleBuy}>
              Buy
            </button>
            <button className="filled">Hold</button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiamonDetails;
